<h2>Enter repeat script tokens:</h2>
<mat-divider></mat-divider>
<div class="amount-hold"></div>
<!-- <form id="reorder-script"> -->
@for (script of data.scripts; track script; let i = $index) {
<div class="full-width">
  <mat-form-field class="full-width" appearance="fill">
    <mat-label>{{ script.drugname }}</mat-label>
    <input
      [(ngModel)]="scripts[i].barcode"
      required
      matInput
      (blur)="checkScriptToken(script, i)"
    />
    @if (!scripts[i].loading && scripts[i].prescription_id) {
    <mat-icon matSuffix>done</mat-icon>
    } @if (scripts[i].loading) {
    <mat-spinner matSuffix [diameter]="20" mode="indeterminate"></mat-spinner>
    }
  </mat-form-field>
  @if (scripts[i].errorMessage) {
  <span class="err-msg">{{ scripts[i].errorMessage }}</span>
  }
</div>
} @if (data.isOrderCompleted) {
<mat-checkbox [(ngModel)]="isRepeatOrder">Repeat Order</mat-checkbox>
}
<!-- </form> -->
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="mm-bg-accent mm-text-white">Close</button>
  <button
    mat-button
    form="reorder-script"
    [disabled]="!isAllTokensVerified || loading"
    (click)="onConfirm()"
    class="mm-bg-primary mm-text-white contains-spinner"
  >
    <span>Confirm</span>
    @if (loading) {
    <mat-spinner class="white-spinner ml-2" diameter="16"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
